exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "/*---------------------------------------------------------------------------------------------\n *  Copyright (c) Microsoft Corporation. All rights reserved.\n *  Licensed under the MIT License. See License.txt in the project root for license information.\n *--------------------------------------------------------------------------------------------*/\n\n.monaco-count-badge {\n\tpadding: 0.2em 0.5em;\n\tborder-radius: 1em;\n\tfont-size: 85%;\n\tfont-weight: normal;\n\ttext-align: center;\n\tdisplay: inline;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./submodules/vscode/src/vs/base/browser/ui/countBadge/countBadge.css
// module id = 527
// module chunks = 0